import { getAccessToken } from '@/service/getSTSToken'

import Vue from 'vue'

function resolveMessage () {
  if (typeof globalThis !== 'undefined' && globalThis.ElementUI && globalThis.ElementUI.Message) {
    return globalThis.ElementUI.Message
  }
  if (typeof window !== 'undefined' && window.ElementUI && window.ElementUI.Message) {
    return window.ElementUI.Message
  }
  if (Vue && Vue.prototype && Vue.prototype.$message) {
    return Vue.prototype.$message
  }
  return null
}

const Message = function (...args) {
  const message = resolveMessage()
  if (typeof message === 'function') {
    return message.apply(null, args)
  }
}

// import store from '@/store'

// import util from '@/tools/util';

const key = 'STSToken'

// oss stsSToken 是否过期
function timeAfter (expirationTime) {
  let now = new Date().getTime()
  console.log(expirationTime)
  let expirationTimeStamp = new Date(expirationTime).getTime()
  console.log(now, expirationTimeStamp)
  if (!expirationTimeStamp) { return true }
  return now > expirationTimeStamp
}

function getSTSToken () {
  // rmSTSToken()

  return Vue.prototype.$cookies.get(key)
}

function setSTSToken (sTSToken) {
  Vue.prototype.$cookies.set(key, sTSToken)
}

export function rmSTSToken () {
  Vue.prototype.$cookies.remove(key)
}

export function getUploadSTSToken (setDefaultErr, headers, forceRefresh = false) {
  const default_err = typeof setDefaultErr === 'function' ? setDefaultErr() : (typeof setDefaultErr === 'string' ? setDefaultErr : '')

  return new Promise((resolve, reject) => {
    const sTSToken = getSTSToken()

    if (forceRefresh || !sTSToken || timeAfter(sTSToken.Expiration)) {
      getAccessToken({}, headers).then((res) => {
        // console.log(res, 'get StSToken');

        const new_sTSToken = {
          ...res.data
        }
        setSTSToken(new_sTSToken)
        resolve({
          errMsg: 'ok',
          sTSToken: new_sTSToken
        })
      }, (err) => {
        window.__bl && window.__bl.error({name: '上传失败getUploadSTSToken', message: JSON.stringify(err)}, {
          filename: 'tools/get-ststoken.js',
          lineno: 60,
          colno: 0
        })

        if (typeof err.status === 'number' && (err.status == 0)) { return false }
        Message({
          type: 'error',
          message: err.body.error ? err.body.error : default_err,
          customClass: 'manban-toast__error'
        })
        const errMsg = err.data && err.data.error ? err.data.error : '上传图片权限获取失败，请稍候在试'
        reject({
          errMsg: errMsg,
          sTSToken: null
        })
      })
    } else {
      resolve({
        errMsg: 'ok',
        sTSToken
      })
    }
  })
}
